import { useRef } from "react";
import logo from "../../assets/logo.png";
import { Link, useLocation } from "react-router-dom";
import SidebarToggler from "./SidebarToggler";
import { Button } from "reactstrap";
import { FaPowerOff } from "react-icons/fa6";
import { commonLinks } from "../../sidebarLinks";
import { useTranslation } from "../../languages";

/**Traditional Sidebar */
const Sidebar = ({ links, isOpen, setIsOpen, onLogoutClick }) => {
  const indicatorRef = useRef();
  const { pathname } = useLocation();
  const clickSoundRef = useRef(new Audio("/sidebar-click-sound.mp3"));
  const { t } = useTranslation();

  //to change indicator styles
  const changeIndicatorStyle = (ref) => {
    if (ref) {
      const { offsetTop, clientHeight } = ref;
      indicatorRef.current.style.setProperty(
        "--jsTransformTop",
        `${offsetTop}px`
      );
      indicatorRef.current.style.setProperty("--jsHeight", `${clientHeight}px`);
    }
  };

  /**speaks the link title using speechSynthesis api */
  const announceLinkName = async (title) => {
    if (window?.SpeechSynthesisUtterance) {
      let utternace = new SpeechSynthesisUtterance(title);
      speechSynthesis?.speak(utternace);
    } else
      console.warn(
        "SpeechSynthesisUtternace api not supported by this browser , use chrome ,safari or firefox"
      );
  };

  return (
    <div className="sidebar" style={{ left: isOpen ? "0" : "-100%" }}>
      <div className="d-flex full-width px-3 justify-content-end">
        <SidebarToggler
          iconColor={"#eee"}
          isOpen={isOpen}
          responsiveClassName={"sidebar-toggler"}
          setisOpen={setIsOpen}
        />
      </div>
      <img
        src={logo}
        height={123}
        width={193}
        className=" object-fit-contain m-3 sidebar-logo"
      />
      <div className="position-relative full-width px-4">
        <div className="sidebar-indicator" ref={indicatorRef}></div>
        {links?.map((l, index) => (
          <Link
            key={index}
            onClick={(e) => {
              changeIndicatorStyle(e?.currentTarget);
            }}
            to={l?.link}
            className={`sidebar-link ${l?.link === pathname ? "active" : ""}`}
          >
            <div>{l?.icon}</div> {t(l?.title)}
          </Link>
        ))}
        {/* common links are common ones e.g faq is both for contributer and user */}
        {commonLinks?.map((l, index) => (
          <Link
            key={index}
            onClick={(e) => {
              changeIndicatorStyle(e?.currentTarget);
            }}
            to={l?.link}
            className={`sidebar-link ${l?.link === pathname ? "active" : ""}`}
          >
            <div>{l?.icon}</div> {t(l?.title)}
          </Link>
        ))}
      </div>
      <Button
        onClick={() => onLogoutClick()}
        className="border-none text-white f-5 py-2 d-flex align-items-center justify-content-center"
        style={{
          background: "rgba(255, 255, 255, 0.05)",
          minWidth: "149px",
          gap: "10px",
        }}
      >
        <FaPowerOff size={24} /> {t("logOut")}
      </Button>
    </div>
  );
};

export default Sidebar;
